import client from './client';
import tracker from '../utils/tracker';

// در لحظه‌ی ثبت‌نام واقعی (register / verify-otp کاربر جدید) شناسه‌ی
// بازدیدکننده و سیگنال‌های اولین بازدید (referrer/utm) به بدنه اضافه می‌شود
// تا سرور بتواند منبع ورود این کاربر را برای همیشه ثبت کند (رجوع کن به
// resolveAcquisition در src/controllers/authController.js).
function withAcquisition(body) {
  return {
    ...body,
    visitorId: tracker.getVisitorId(),
    firstTouch: tracker.getFirstTouch()
  };
}

export const authAPI = {
  loginAdmin: (username, password) =>
    client.post('/auth/admin/login', { username, password }),

  registerAdmin: (username, email, password) =>
    client.post('/auth/admin/register', { username, email, password }),

  loginUser: (phoneNumber, password) =>
    client.post('/auth/login', { phoneNumber, password }),

  registerUser: (firstName, lastName, phoneNumber, email, username, password) =>
    client.post('/auth/register', withAcquisition({
      firstName,
      lastName,
      phoneNumber,
      email,
      username,
      password
    })),

  getCurrentUser: () => client.get('/auth/me'),

  checkPhone: (phoneNumber) =>
    client.post('/auth/check-phone', { phoneNumber }),

  requestOTP: (phoneNumber, inviteCode) =>
    client.post('/auth/request-otp', { phoneNumber, ...(inviteCode ? { inviteCode } : {}) }),

  verifyOTP: (phoneNumber, otp, referralCode) =>
    client.post('/auth/verify-otp', withAcquisition({ phoneNumber, otp, ...(referralCode ? { referralCode } : {}) })),

  getPublicSettings: () =>
    client.get('/auth/public-settings'),

  getReferralStats: () =>
    client.get('/auth/referral/stats'),

  inviteFriend: (firstName, lastName, phone) =>
    client.post('/auth/referral/invite-friend', { firstName, lastName, phone }),

  getMyInvitations: () =>
    client.get('/auth/referral/my-invitations'),

  sendInvitationSMS: (invitationId) =>
    client.post('/auth/referral/send-invite-sms', { invitationId }),
};

// Convenience exports for direct imports
export const checkPhone = (phoneNumber) => authAPI.checkPhone(phoneNumber);
export const requestOTP = (phoneNumber, inviteCode) => authAPI.requestOTP(phoneNumber, inviteCode);
export const verifyOTP = (phoneNumber, otp, referralCode) => authAPI.verifyOTP(phoneNumber, otp, referralCode);
export const getCurrentUser = () => authAPI.getCurrentUser();
export const getPublicSettings = () => authAPI.getPublicSettings();
export const getReferralStats = () => authAPI.getReferralStats();
export const inviteFriend = (firstName, lastName, phone) => authAPI.inviteFriend(firstName, lastName, phone);
export const getMyInvitations = () => authAPI.getMyInvitations();
export const sendInvitationSMS = (invitationId) => authAPI.sendInvitationSMS(invitationId);
